// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editing[data-v-151847b2] {
  text-overflow: clip;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/channels/PublicationEditableItemText.vue"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB","sourcesContent":[".editing[data-v-151847b2] {\n  text-overflow: clip;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
